import { CSSProperties } from 'react';
import { Box, Loader, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { format } from 'date-fns';

interface ManualRefreshProps {
  lastFetch: Date | undefined;
  isFetching: boolean;
  refresh: () => void;
  style?: CSSProperties;
}

export const RefreshDisplay: React.FC<ManualRefreshProps> = ({ lastFetch, isFetching, refresh, style }) => {
  return (
    <Box display="flex" alignItems="center" ml="auto" justifyContent="flex-end" style={style}>
      {lastFetch && !isFetching && <Text>Last Updated at {format(lastFetch, 'hh:mm a')}</Text>}
      {isFetching && <Loader size="20px" />}

      <Button color="tertiary" style={{ marginLeft: '8px' }} size="small" onClick={refresh} disabled={isFetching}>
        Refresh now
      </Button>
    </Box>
  );
};
